<script setup lang="ts">import { computed as _computed } from 'vue';

import { GetDataProductResponseDto } from '@/api';
import i18n from '@/i18n';
import SChip from '@/components/SChip.vue';
import { SChipColors } from '@/components/SChipTypes';

interface DataProductQualityStatusProps {
  status: GetDataProductResponseDto.dataProductStatus | GetDataProductResponseDto.dataProductUpstreamStatus;
}

const props = defineProps({
  status: null
});

type ChipInfo = {
  text: string;
  color: SChipColors;
  icon: string;
};

const chip = _computed((): ChipInfo => {
  switch (props.status) {
    case GetDataProductResponseDto.dataProductStatus.HEALTHY:
      return { text: i18n.t('qualityStatus.data_products_labels.healthy') as string, color: SChipColors.SUCCESS, icon: 'icon-check-circle-fill' };
    case GetDataProductResponseDto.dataProductStatus.AT_RISK:
      return { text: i18n.t('qualityStatus.data_products_labels.at_risk') as string, color: SChipColors.WARNING, icon: 'icon-warning-fill' };
    case GetDataProductResponseDto.dataProductStatus.CRITICAL:
      return { text: i18n.t('qualityStatus.data_products_labels.critical') as string, color: SChipColors.FAILURE, icon: 'icon-error-circle-fill' };
    default:
      return { text: i18n.t('qualityStatus.data_products_labels.not_supported') as string, color: SChipColors.NEUTRAL, icon: 'icon-circle-slash' };
  }
});
</script>

<template lang="pug">
SChip(
  :color="chip.color"
  :text="chip.text"
  :icon="chip.icon"
  emphasize
)
</template>
